import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import MaterialIcon from './MaterialIcon';
import PicabooComponentBase from './PicabooComponentBase';
import styles from './styles.less';

class PicabooModal extends PicabooComponentBase {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    //we really only need to check the show prop and children
    //anything else wont happen when the modal is showing
    return (
      nextProps.show !== this.props.show ||
      nextProps.children !== this.props.children
    );
  }

  render() {
    return (
      <div>
        <Modal
          centered
          scrollable={this.props.scrollable}
          onHide={this.props.onHide}
          dialogClassName={this.props.dialogStyle}
          backdrop={false}
          show={this.props.show}
          className={this.props.modalStyle ? this.props.modalStyle : ''}
          size={this.props.bsSize ? this.props.bsSize : null}
        >
          <MaterialIcon
            icon="close"
            onClick={this.props.onHide}
            classOverride={classNames(styles.close, styles.modalCloseButton)}
          />
          {this.props.modalTitle && (
            <Modal.Header>
              <Modal.Title>{this.props.modalTitle}</Modal.Title>
            </Modal.Header>
          )}
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

PicabooModal.propTypes = {
  show: PropTypes.bool,
  dialogStyle: PropTypes.string,
};

export default PicabooModal;
